export default [
  { name: "Apartments" },
  { name: "Arcade" },
  { name: "Baby Changing" },
  { name: "Bar" },
  { name: "Bbqs" },
  { name: "Bus" },
  { name: "Cafe" },
  { name: "Disabled Suite" },
  { name: "Dish Washing" },
  { name: "Dog Wash" },
  { name: "Dog Walking" },
  { name: "Drying area" },
  { name: "Dustbins" },
  { name: "Entertainment" },
  { name: "Family Room" },
  { name: "Fishing" },
  { name: "Freezers" },
  { name: "Games Room" },
  { name: "Gym" },
  { name: "Hand Dryers" },
  { name: "Hair Dryers" },
  { name: "Hot Tub" },
  { name: "Internet Access" },
  { name: "Ironing" },
  { name: "Jacuzzi" },
  { name: "Laundry" },
  { name: "Library" },
  { name: "Patio" },
  { name: "Play Area" },
  { name: "Putting Green" },
  { name: "Power Sockets" },
  { name: "Reception" },
  { name: "Recycling" },
  { name: "Restaurant" },
  { name: "Showers" },
  { name: "Shop" },
  { name: "Swimming Pool" },
  { name: "Sun loungers" },
  { name: "Takeaway" },
  { name: "Telephone" },
  { name: "Walk" },
  { name: "Washroom" },
  { name: "Waste disposal" },
  { name: "Water" },
  { name: "Wetsuit Wash" },
  { name: "Other" },
]
